import type { Dayjs } from 'dayjs';

import { DAY_OF_WEEK } from 'app/typings/core/common/enum/dayOfWeek';
import type { DayOfWeek } from 'app/typings/core/common/enum/dayOfWeek';
import { DAYS_OPTIONS } from 'app/typings/core/extranet/constants/days';

export const ALL_WEEKDAYS = DAYS_OPTIONS.map((option) => option.value);

export const DAY_OF_WEEK_TO_ISO_WEEKDAY: Record<DayOfWeek, number> = {
  [DAY_OF_WEEK.MONDAY]: 1,
  [DAY_OF_WEEK.TUESDAY]: 2,
  [DAY_OF_WEEK.WEDNESDAY]: 3,
  [DAY_OF_WEEK.THURSDAY]: 4,
  [DAY_OF_WEEK.FRIDAY]: 5,
  [DAY_OF_WEEK.SATURDAY]: 6,
  [DAY_OF_WEEK.SUNDAY]: 7,
};

export const getIsoWeekday = (date: Dayjs): number => {
  const day = date.day();

  return day === 0 ? 7 : day;
};

export const isoWeekdayToJsDay = (isoWeekday: number): number => isoWeekday % 7;

export const resolveCustomWeekdays = (weekdays?: number[]): number[] =>
  weekdays && weekdays.length > 0 ? weekdays : ALL_WEEKDAYS;

export const addWeekday = (weekdays: number[], day: number): number[] =>
  weekdays.includes(day) ? weekdays : [...weekdays, day];
